module.exports = __webpack_public_path__ + "media/images/pic/owners-68f80d5cbe8d82a8325f81859f6e2976.webp";